// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"806":"user","884":"admin"}[chunkId] || chunkId) + "." + {"484":"17bc0860","607":"e519b58a","806":"b7cb0b5f","884":"ae651379"}[chunkId] + ".css";
};